export default __webpack_public_path__ + "static/media/ArrowRight.92e01bd7.svg";